module.exports = __webpack_public_path__ + "img/aadenLogo.3ea07961.png";